module.exports = __webpack_public_path__ + "static/dosimetrist-40eb21d9ed39fef7520eeefef3d9422b.jpeg";